import React from "react";
import { checkTextTranslation, getObject, setObject, translate } from "../../utils/useful";
// import SelectInput from "./SelectInput";
// import SwitchInput from "./SwitchInput";
import FormViewer from "../FormViewer";
import FixedView from "../FixedView";
import HttpServices from "../../utils/Http.services";

// used for making the prop types of this component
// import PropTypes from "prop-types";

class StockInput extends React.Component {
    state = {
        value: '',
        showValue: '',
        rawHeaders: [


            { key: 'track', type: 'SwitchInput', col: "6", information: { label: '{{lang}}Track Inventory', required: false, default: false }, showMain: true },

            {
                key: 'outOfStock', type: 'SwitchInput', col: "6", information: { label: '{{lang}}Out of stock', required: false, default: false },
                dependencies: [{
                    refKey: 'track', targetKey: 'outOfStock',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.track' }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true }
                    }],
                    else: { show: false },
                    init: true,

                }],
                showMain: true
            },
        ],

        warehousesField: {
            type: 'SubformInput',
            key: 'warehouses',
            information: {
                // addDisabled: true, removeDisabled: true,
                headers: [
                    // { key: 'warehouse', type: 'SelectInput', col: '3', information: { label: '{{lang}}Warehouse', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },
                    // { key: 'stock', type: 'NumberInput', col: '3', information: { label: '{{lang}}Stock', placeholder: '0', required: false } },
                    // { key: 'stockValue', type: 'PriceInput', col: '3', information: { label: '{{lang}}Stock Value', placeholder: '0', required: false } },
                    // { key: 'section', type: 'SelectInput', col: '3', information: { label: '{{lang}}Section', address: 'getWarehouses', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: false },

                ],

                required: false
            },
            dependencies: [{
                refKey: 'track', targetKey: 'warehouses',
                conditions: [{
                    root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.track' }, operator: { value: '==' }, target: { value: true } } }, },
                    effect: { show: true }
                }],
                else: { show: false },
                init: true,

            }],
            showMain: true
        },
    }

    componentDidMount() {

        // console.log("AA",JSON.parse(JSON.stringify(this.props.data)))
        setTimeout(() => {
            this.setState({ show: true })

        }, 1);



        // console.log()
        let body = { applet: this.props.variables?.appletId }
        let isEdit = false
        if (this.props.fullData?._id) {
            isEdit = true
        }

        if (!isEdit) {
            HttpServices.request("getWarehouses", body, (fetchResult, fetchError) => {



                if (fetchError) { return }

                if (fetchResult?.info) {

                    let headers = [...this.state.rawHeaders]
                    let warehousesField = this.state.warehousesField

                    let warehouses = []
                    let sections = []
                    let activateSections = false

                    fetchResult.info.forEach(warehouse => {

                        warehouses.push({ value: warehouse._id, title: warehouse.name })

                        if (warehouse.activateSections && Array.isArray(warehouse.sections)) {

                            activateSections = true

                            warehouse.sections.forEach(section => {

                                sections.push({ value: section._id, title: section.name, parent: warehouse._id })

                            });
                        }


                    })

                    warehousesField.information.headers = [
                        { key: 'warehouse', type: 'SelectInput', col: '3', information: { label: '{{lang}}Warehouse', address: 'getWarehouses', filter: {}, items: warehouses, type: 'local', isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: true },
                        { key: 'count', type: 'NumberInput', col: '3', information: { label: '{{lang}}Count', placeholder: '0', required: false } },
                        { key: 'cost', type: 'PriceInput', col: '3', information: { label: '{{lang}}Cost', placeholder: '0', required: false } },

                    ]

                    if (activateSections) {
                        warehousesField.information.headers.push(
                            { key: 'section', type: 'SelectInput', col: '3', information: { label: '{{lang}}Section', address: 'getWarehouses', filter: { '*row.parent': "{{warehouse}}" }, items: sections, type: 'local', rowDependant: true, isSearchable: true, placeholder: '{{lang}}Select ...', required: false }, showMain: true },
                        )
                    }

                    // console.log(this.props.data)
                    if (!this.props.data?.warehouses) {

                        let data = this.props.data ?? {}

                        data.warehouses = []
                        warehouses.forEach(warehouse => {
                            data.warehouses.push({ warehouse: warehouse.value, })
                        })




                        this.props.changeValue(this.props.header?.key, data, this.props.extra)


                    }

                    if (!isEdit) {
                        headers = [...headers, warehousesField]
                    }

                    this.setState({ headers })

                    // console.log(warehouses)
                    // console.log(sections)

                    // console.log(fetchResult)

                }
            })

        } else {

            let headers = [...this.state.rawHeaders]
            this.setState({ headers })


        }

        this.setState({ isEdit })
    }

    componentDidUpdate(prevProps) {

    }






    openfixView = () => {

        this.fixView.showView()
        setTimeout(() => {
            this.fixView.getBounding()
        }, 1);

    }

    // changeFixedValue = (key, value, extra) => {

    //     this.props.changeValue(key, value, extra)
    //     // this.setState({ value: value, showValue: this.changeToPriceValue(value) })
    //     setTimeout(() => {
    //         this.fixView.getBounding()
    //     }, 1);
    // }

    liveChange = (data, init, key, value, extra, full) => {

        // console.log("liveChange")
        let availableCount = 0

        if (!this.state.isEdit) {
            if (Array.isArray(data.warehouses)) {
                data.warehouses.forEach(warehouse => {
                    availableCount = availableCount + (warehouse.count ?? 0)
                })
            }

            data.availableCount = availableCount
            data.count = availableCount
        }
        // console.log("data", data)
        // console.log(availableCount)
        setTimeout(() => {
            this.fixView.getBounding()
        }, 10);

        // console.log(data)

        this.props.changeValue(this.props.header?.key, data, this.props.extra)
    }




    render() {


        // console.log(this.props.data)

        return (
            <div className='mt-0 w-100 flexc flex-1' ref={el => this.firstCurrentNode = el}>

                {/* {this.props.inplaceView && ( */}
                <>
                    <button className="w-100 flex-1 flexc" onClick={() => this.openfixView()}>
                        {/* {(data?.length?.value || data?.width?.value || data?.height?.value || data?.weight?.value) ? ( */}
                        <div className=" w-100">

                            {this.props.data?.track && (
                                <>

                                    {this.props.data?.outOfStock ? (
                                        <p className="text-smaller color-gray-1 text-semibold w-100 text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{translate('Out of stock')}</p>
                                    ) : (
                                        <div className="w-100 text-start">
                                            {(this.props.data?.count) ? (
                                                <p>{this.props.data?.count}</p>
                                            ) : (
                                                <p className="placeholder text-start"> {this.props.information?.placeholder ?? translate('Value ...')}</p>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}

                            {!this.props.data?.track && (
                                <div className="flexcb">
                                    <p className="text-smaller color-gray-1 text-semibold">{translate("Unlimited")} </p>
                                    {/* ∞ */}
                                    {/* <div>
                                            <div className="br-4 px-2 py-1 w-100" style={{ backgroundColor: '#10101010' }}>
                                                <p className="text-smallest color-gray-1 text-semibold w-100" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>Not tracking</p>
                                            </div>
                                        </div> */}
                                </div>
                            )}


                        </div>
                        {/* ) : (
                                <p className="placeholder"> {this.props.information?.placeholder ?? translate('Value ...')}</p>
                            )} */}

                    </button>
                    {this.state.show && (
                        <FixedView ref={el => this.fixView = el} nodeRef={this.firstCurrentNode} showFocus={false} fixed={this.state.fixed} topOffset={7} bottomOffset={22} xOffset={0} zIndex={20} width={this.props.data?.track ? 440 : 240} >
                            <div className=" px-2 pt-3 pb-1  d-flex flex-column w-100 " style={{ boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 10 }}>

                                <FormViewer ref={el => this.form = el} initData={this.props.data} liveChange={this.liveChange} headers={this.state.headers} formClass="bordered-form " inputClass={'bordered-input'} nopadding={true} variables={this.props.variables} marginBottom={0} />


                                {this.state.isEdit == true && this.props.data?.track && !this.props.data?.outOfStock && (
                                    <div className="text-semibold mb-3 px-1">
                                        {/* {console.log(this.props.data)} */}
                                        <p className="text-bold font-size-16">{translate("Total stock")}: {this.props.data?.count}</p>
                                        {this.props.data?.snapshot && Object?.keys(this.props.data?.snapshot)?.length > 0 && (
                                            <div className="mt-2 pt-2" style={{ borderTop: '1px solid #eee' }}>
                                                {/* <p className="font-size-14 text-semibold">{translate("Detail")}</p> */}
                                                {Object?.keys(this.props.data?.snapshot).map((sKey) => {
                                                    return (
                                                        <div>
                                                            <p className="text-capitalize">{translate(sKey)}: {this.props.data?.snapshot[sKey]}</p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        )}

                                    </div>
                                )}
                            </div>



                        </FixedView>

                    )}




                </>
                {/* )} */}


            </div>
        );
    }
}

export default StockInput;
